import { lazy, Suspense } from 'react';

import { useConnectEmailPromptStore } from '../../store/ConnectEmailPrompt/useConnectEmailPromptStore';

const ConnectEmailPromptDialog = lazy(
  () => import('../ConnectEmailPromptDialog/ConnectEmailPromptDialog'),
);

export function GlobalConnectEmailPromptDialog() {
  const isOpen = useConnectEmailPromptStore((s) => s.isOpen);
  const close = useConnectEmailPromptStore((s) => s.close);

  if (!isOpen) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ConnectEmailPromptDialog isOpen={isOpen} onClose={close} />
    </Suspense>
  );
}
